module.exports = __webpack_public_path__ + "media/images/products/IMG_20210704_165539_HDR-removebg-preview-94937e13149246f91cd6e766dc03052c.png";